import React, { useEffect } from 'react'
import AsyncSelect, { Props } from 'react-select/async'
import { useApolloClient } from '@apollo/client'
import { useDebouncedCallback } from 'use-debounce'
import { t } from '@lingui/macro'
import { Text, Flex } from '@chakra-ui/layout'
import {
  SingleValueProps,
  OptionProps,
  components,
  ValueType,
  ActionMeta
} from 'react-select'
import {
  ReactSelectLooopStyles,
  SelectVariant
} from 'front-end/src/components/common/select/Select'
import { brandColors } from 'shared/basicPalette'

import { FacilitatorsDocument } from './Facilitator.codegen'

interface OptionUser {
  display_name: string | null | undefined
  image_url?: string | null
  id: number
  userIdentity: string
}

const SingleValue = ({ data, ...props }: SingleValueProps<OptionUser>) => {
  return (
    <components.SingleValue data={data} {...props}>
      <Flex>
        <Text color={brandColors.grey.dark}>{data.display_name}</Text>
        <Text ml="1" color={brandColors.grey.mid}>
          ({data.userIdentity})
        </Text>
      </Flex>
    </components.SingleValue>
  )
}
const Option = ({ data, ...props }: OptionProps<OptionUser, false>) => {
  return (
    <components.Option data={data} {...props}>
      <Flex>
        <Text color={brandColors.grey.dark}>{data.display_name}</Text>
        <Text ml="1" color={brandColors.grey.mid}>
          ({data.userIdentity})
        </Text>
      </Flex>
    </components.Option>
  )
}

export const FacilitatorSelector = ({
  value,
  onChange
}: {
  value?: OptionUser | null
  onChange: (
    value: ValueType<OptionUser, false>,
    action?: ActionMeta<OptionUser>
  ) => void
}) => {
  const client = useApolloClient()

  const callback = useDebouncedCallback((value: string, callback) => {
    client
      .query({
        query: FacilitatorsDocument,
        variables: { search: value }
      })
      .then(({ data }) => {
        callback(data.users)
      })
      .catch((e) => {
        console.error(e)
      })
  }, 700)

  useEffect(callback.cancel, [])

  const props: Props<OptionUser, false> = {
    menuPlacement: 'auto',
    loadOptions: callback,
    components: {
      SingleValue,
      Option,
      DropdownIndicator: () => null,
      IndicatorSeparator: () => null
    },
    styles: {
      ...ReactSelectLooopStyles(SelectVariant.GREY)
    },
    placeholder: t`Not selected`,
    noOptionsMessage: () => t`No results`,
    isClearable: true,
    value,
    onChange
  }
  return <AsyncSelect {...props} />
}
